import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import api from '../api/client';
import './Basket.css';

export default function Basket({ translations }) {
    const [basket, setBasket] = useState(null);
    const [loading, setLoading] = useState(true);
    const [removing, setRemoving] = useState(null);
    const t = (key, fallback) => translations?.[key] || fallback;

    useEffect(() => {
        let active = true;
        api.getBasket()
            .then((data) => { if (active) setBasket(data); })
            .catch(() => { if (active) setBasket(null); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, []);

    const handleRemove = async (publicId) => {
        setRemoving(publicId);
        try {
            const updated = await api.removeFromBasket(publicId);
            setBasket(updated);
            window.dispatchEvent(new Event('basket:changed'));
        } catch {
            // Ignore
        } finally {
            setRemoving(null);
        }
    };

    const items = basket?.items || [];
    const total = items.reduce((sum, it) => sum + (Number(it.price) || 0), 0);

    return (
        <>
            <Header translations={translations} />
            <div className="basket-container">
                <h1 className="basket-title">{t('basket-title', 'My basket')}</h1>
                {loading ? (
                    <div className="loading-page"><div className="spinner" /></div>
                ) : items.length === 0 ? (
                    <p className="basket-empty">{t('basket-empty', 'Your basket is empty.')}</p>
                ) : (
                    <>
                        <ul className="basket-list">
                            {items.map((it) => {
                                const img = it.filesURL?.compressed || it.filesURL?.watermarked || '';
                                return (
                                    <li key={it.publicId} className="basket-item">
                                        <Link to={`/picture/${it.publicId}`} className="basket-item-img-link">
                                            {img ? (
                                                <img src={img} alt="" className="basket-item-img" />
                                            ) : (
                                                <div className="basket-item-img placeholder" />
                                            )}
                                        </Link>
                                        <div className="basket-item-info">
                                            <p className="basket-item-desc">{it.description || t('basket-untitled', 'Untitled')}</p>
                                            {it.price > 0 && <p className="basket-item-price">€{it.price}</p>}
                                        </div>
                                        <button
                                            className="basket-remove"
                                            onClick={() => handleRemove(it.publicId)}
                                            disabled={removing === it.publicId}
                                        >
                                            {t('basket-remove', 'Remove')}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                        {total > 0 && (
                            <div className="basket-total">
                                <span>{t('basket-total', 'Total')}</span>
                                <strong>€{total}</strong>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
}
